import { format, isSameDay } from "date-fns";
import { TFunction } from "i18next";

import { SupervisorQueueItem } from "../store/supervisor-home-types";

// Time-only when the item falls on today, date-prefixed otherwise — time-off
// requests routinely start days out, and a bare "8:00 AM" would read as today.
export function formatQueueItemWhen(
	item: SupervisorQueueItem,
	today: Date
): string {
	const start = new Date(item.startDateTime);
	const end = new Date(item.endDateTime);
	const range = `${format(start, "h:mm a")} – ${format(end, "h:mm a")}`;

	return isSameDay(start, today)
		? range
		: `${format(start, "MMM d")} · ${range}`;
}

// Reuses the shared hour/minute strings so durations read the same here as
// they do on the worker side.
export function formatQueueItemDuration(
	item: SupervisorQueueItem,
	t: TFunction
): string {
	const totalMinutes = Math.max(
		0,
		Math.round(
			(new Date(item.endDateTime).getTime() -
				new Date(item.startDateTime).getTime()) /
				60000
		)
	);
	const hours = Math.floor(totalMinutes / 60);
	const minutes = totalMinutes % 60;
	const parts: string[] = [];

	if (hours > 0) {
		parts.push(
			`${hours} ${
				hours === 1 ? t("helpers_hour-text") : t("helpers_hours-text")
			}`
		);
	}
	if (minutes > 0 || hours === 0) {
		parts.push(
			`${minutes} ${
				minutes === 1 ? t("helpers_minute-text") : t("helpers_minutes-text")
			}`
		);
	}

	return parts.join(" ");
}

// Slots come back as a float (e.g. 2.0) because a partial signup can fill part
// of a slot; round for display so a row never reads "2.5 of 4 spots filled".
export function getOpenShiftSpots(item: SupervisorQueueItem): {
	filled: number;
	needed: number;
	remaining: number;
} {
	const filled = Math.round(item.slotsFilled ?? 0);
	const needed = item.numberOfWorkersNeeded ?? 0;

	return { filled, needed, remaining: Math.max(0, needed - filled) };
}
